
import { getUserInfo, isWeiXin, system, isApp, shareFun, callApp } from '@/util/const'
import  BoxWindow from './BoxWindow';
import {getQueryVariable } from '@/util/const'
import { setAuthorization } from '../../axios/userInfo'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import defaultImg from '../../../static/img/birthday/life_jk_phb_touxiang_a@2x.png'

export default {
components: {
'BoxWindow': BoxWindow,
Flexbox,
FlexboxItem,
},
data () {
return {
defaultImg,
openInBrowser: false,
status: 1,
phoneNumber: '20200312',
sendNumber:'',
send:3,
sendUser:'1',
isget:0,
boxShow:false,
tagHref: {
series_update: 'openpage://3520',
recommend_update: 'openpage://8600'
},
bg: this.$t('birthday.bg'),
resultType:4,
type:9,
isIos: system(),
isWeiXin: isWeiXin(),

}
},
created () {
this.phoneNumber = Base64.decode(this.$route.params.index)
this.phoneNumber = this.phoneNumber.replace(/\"/g, "")
window.getUserInfo = (obj) => {
console.log('setAuthorization')
if (obj) {
setAuthorization(obj.authorization)
console.log(obj)
this.sendNumber = obj.user.phone
this.shareGift()
}
}
},
mounted () {

},
methods: {
hideBox() {
this.boxShow = false;
},
shareGift (){
if(this.phoneNumber === this.sendNumber){
this.type = 9
this.boxShow = true;
return
}
this.$http.get(`/ticket_racing/birthdaygift/shareGift`, { from: this.phoneNumber, to: this.sendNumber}).then(res => {
console.log('res',res)
this.resultType = res.data.body.result
switch (this.resultType) {
case 0:
this.type = 3
this.boxShow = true;
break
case 1:
this.type = 4
this.boxShow = true;
break
case 2:
this.type = 5
this.boxShow = true;
break
case 3:
this.type = 6
this.boxShow = true;
break
case 4:
this.type = 7
this.isget = 1
this.boxShow = true;
break
case -1:
this.type = 8
this.boxShow = true;
break
default:
break
}
})
},
detail () {
this.$alert({
content: {
title: this.$t('birthday.title1'),
list: this.$t('birthday.rule2')
}
})
},
receive () {
if (this.isWeiXin) {
this.openInBrowser = true
return
}
if (!isApp()) {
callApp()
return
}
if (isApp()) {
getUserInfo({callbackName: 'getUserInfo', needLogin: true})
}
},
jump() {
let url = 'openpage://50200'
window.location.href = url
}
}
}



// WEBPACK FOOTER //
// ./src/page/birthday/birthdaysend.vue